import { Component, Input, OnChanges, SimpleChanges, ViewChild, AfterViewChecked } from '@angular/core';

import { ProfilePictureService } from '../../../services/profile-picture.service';
import { Configuration } from '../../../../shared/configurations/shared.config';

@Component({
    moduleId: module.id,
    providers: [ProfilePictureService],
    selector: 'preview-profile-picture',
    templateUrl: 'preview-profile-picture.component.html',
    styleUrls: ['./preview-profile-picture.component.scss']
})

export class PreviewPictureComponent implements AfterViewChecked {
    @Input("pictureId") pictureId: number;
    @Input("class") class: string;
    @Input() defaultUrl: string = "/assets/img/default-img.png";
    @Input() backgroundImageUrl: string;
    @ViewChild('profileImg') profileImg;
    baseUrl: string = Configuration.urls.webApiEndpoint + Configuration.urls.pictureById;
    axis: string;
    constructor(private _profilePictureService: ProfilePictureService) {
    }

    ngAfterViewChecked() {
        //this.checkImg();
    }
    removePicture(): void {
        this.pictureId = 0;
    }
    checkImg() {
        //debugger
        if (this.profileImg.nativeElement.naturalWidth > this.profileImg.nativeElement.naturalHeight)
            this.axis = 'horizontal';
        else
            this.axis = 'vertical';
    }
}




// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/profilePicture/previewProfilePicture/preview-profile-picture.component.ts